import React from 'react';
import './Input.css';

interface InputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    label?: string;
    type?: 'text' | 'number' | 'email' | 'password';
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Input: React.FC<InputProps> = ({
    value,
    onChange,
    placeholder = '',
    disabled = false,
    label,
    type = 'text',
    onKeyDown,
}) => {
    return (
        <div className="input-container">
            {label && <label className="input-label">{label}</label>}
            <input
                type={type}
                className="input-field"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                onKeyDown={onKeyDown}
            />
        </div>
    );
};

export default Input;
